module.exports = __webpack_public_path__ + "img/logo_T2_outline.a32899fa.svg";